/* 🤖 this file was generated by script */
export const wiconArrowNarrowUp = {
  name: 'arrow_narrow_up',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 20V4m0 0l-6 6m6-6l6 6"/></svg>`,
};
